/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ExternalMCPHeaderDefinition = {
  /**
   * Description of the header
   */
  description?: string | undefined;
  /**
   * The actual HTTP header name to send (e.g., X-Api-Key)
   */
  headerName: string;
  /**
   * The prefixed environment variable name (e.g., SLACK_X_API_KEY)
   */
  name: string;
  /**
   * Placeholder value for the header
   */
  placeholder?: string | undefined;
  /**
   * Whether the header is required
   */
  required: boolean;
  /**
   * Whether the header value is secret
   */
  secret: boolean;
};

/** @internal */
export const ExternalMCPHeaderDefinition$inboundSchema: z.ZodMiniType<
  ExternalMCPHeaderDefinition,
  unknown
> = z.pipe(
  z.object({
    description: z.optional(z.string()),
    header_name: z.string(),
    name: z.string(),
    placeholder: z.optional(z.string()),
    required: z.boolean(),
    secret: z.boolean(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "header_name": "headerName",
    });
  }),
);

export function externalMCPHeaderDefinitionFromJSON(
  jsonString: string,
): SafeParseResult<ExternalMCPHeaderDefinition, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ExternalMCPHeaderDefinition$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ExternalMCPHeaderDefinition' from JSON`,
  );
}
